/** * * Asynchronously loads the component for
Consume Cellular
* */ import { lazyLoad } from "utils/loadable";
export const ConsumeCellular = lazyLoad(
  () => import("./index"),
  (module) => module.ConsumeCellular
);
